import {
  AppSearch,
  AppSearchResponse,
  CreateJobModel,
  CreateLoadPullRequestJobModel,
  JobChainDagResponse,
  JobChainData,
  JobListData,
  JobChainDetail,
  JobChainFilterData,
  JobItemTemplate,
  JobStatus,
  JobTag,
  JobTemplate,
  SelectOption,
} from '@/types';
import {
  Core,
  CREATE_JOB,
  CREATE_LOAD_PULL_REQUEST_JOB,
  JOB_STATUS,
  JOB_TAG,
  JOB_TEMPLATE,
  JOB_TYPES,
  JOB_CHAINS,
  JOBS,
  JOB_EXPORT,
  JOB_CHAIN_FILTERS,
  UPDATE_JOB_ITEM_STATUS,
  UPDATE_JOB_STATUS,
  JOB_CHAIN_DAG,
} from '../Core';

class Jobs extends Core {
  getJobChains = async (query: AppSearch<JobChainData>) =>
    this.post<AppSearchResponse<JobChainData>>(JOB_CHAINS(), query);

  getJobs = async (query: AppSearch<JobListData>) =>
    this.post<AppSearchResponse<JobListData>>(JOBS(), query);

  exportJobs = async (
    query: AppSearch<JobListData> & { format: 'xlsx' | 'csv' },
  ) => this.post<Blob>(JOB_EXPORT(), query, { responseType: 'blob' });

  getJobChainDetails = async (jobChainId: number) =>
    this.get<JobChainDetail>(JOB_CHAINS(jobChainId));

  getJobChainDag = async (jobChainId: number) =>
    this.get<JobChainDagResponse>(JOB_CHAIN_DAG(jobChainId));

  getJobChainFilters = async () =>
    this.get<JobChainFilterData>(JOB_CHAIN_FILTERS());

  createJob = async (data: CreateJobModel) => this.post(CREATE_JOB(), data);

  createLoadPullRequestJob = async (data: CreateLoadPullRequestJobModel) =>
    this.post(CREATE_LOAD_PULL_REQUEST_JOB(), data);

  updateJobStatus = async (data: { jobId: number; jobStatusId: number }) =>
    this.patch(UPDATE_JOB_STATUS(), data);

  updateJobItemStatus = async (data: {
    jobId: number;
    jobItemId: number;
    jobStatusId: number;
  }) => this.patch(UPDATE_JOB_ITEM_STATUS(), data);

  getJobTypes = async () => this.get<SelectOption<string>[]>(JOB_TYPES());

  getJobStatus = async () => this.get<JobStatus[]>(JOB_STATUS());

  getJobTags = async () => this.get<JobTag[]>(JOB_TAG());

  createJobTag = async (data: JobTag) => this.put(JOB_TAG(), data);

  updateJobTag = async (data: JobTag) => this.patch(JOB_TAG(), data);

  deleteJobTag = async (data: { id: number; unDelete?: boolean }) =>
    this.delete(JOB_TAG(), data);

  getJobTemplates = async () => this.get<JobTemplate[]>(JOB_TEMPLATE());

  getJobItemTemplates = async (jobTemplateId: number) =>
    this.get<JobItemTemplate[]>(JOB_TEMPLATE(jobTemplateId));
}

export const jobs = new Jobs();
